import { render, staticRenderFns } from "./DevQrcode.vue?vue&type=template&id=63baef76&scoped=true&"
import script from "./DevQrcode.vue?vue&type=script&lang=js&"
export * from "./DevQrcode.vue?vue&type=script&lang=js&"
import style0 from "./DevQrcode.vue?vue&type=style&index=0&id=63baef76&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63baef76",
  null
  
)

export default component.exports